module.exports = __webpack_public_path__ + "static/media/refurbishCarpet.633152cc.jpg";